import React from 'react';
import { ArrowRight } from 'lucide-react';

const AmazonSection = ({ onOpenModal }) => (
  <section className="py-16 md:py-20 bg-[#1A3628] relative overflow-hidden" data-testid="home-amazon-section">
    {/* Subtle glow */}
    <div className="absolute inset-0 opacity-15" style={{ background: 'radial-gradient(ellipse at 50% 50%, #2D5A43 0%, transparent 70%)' }} />

    <div className="max-w-3xl mx-auto px-6 md:px-12 text-center relative z-10">
      <p className="eyebrow mb-6">Protect Your Brand</p>
      <h2 className="font-display text-4xl md:text-5xl font-bold text-[#F9F8F6] tracking-tighter leading-tight mb-6">
        Ready to Secure Your Trademark?
      </h2>
      <p className="font-body text-lg text-[#F9F8F6]/50 mb-12 max-w-xl mx-auto leading-relaxed">
        Don't wait until someone else trademarks your brand name. Get USPTO trademark registration through experienced IP attorneys — starting from just $45.
        
      </p>
      <button
        onClick={() => onOpenModal?.('Start Trademark Registration')}
        className="bg-[#C85A40] hover:bg-[#A64730] text-white font-body font-medium rounded-full px-12 py-5 text-base inline-flex items-center gap-3 transition-all duration-300 hover:scale-[1.02]"
        data-testid="home-amazon-cta-btn"
      >
        Start Trademark Registration
        <ArrowRight className="h-5 w-5" strokeWidth={1.5} />
      </button>
    </div>
  </section>
);

export default AmazonSection;
